<template>
  <div class="add headFixed bodyPd hasBotBtns">
    <div class="fixed_head">
      <div class="content">
        <div class="go_back">
          <span @click="$router.back(-1)" class="goBackBtn"></span>
          <span class="titles">场景管理</span>
          <span class="right addHome" @click="addHome()">添加</span>
        </div>

      </div>
    </div>
    <!-- 住宅列表 -->
    <div class="roomWrapper">
      <div class="list list_prev list_normal">
        <p class="titleTip">请添加或修改设备所在的地址或小区名称</p>
        <div class="item choose-item" :class="index==currentIndex?'choose-active':''"
             v-for="(data,index) in list"
             :key="index">
          <div class="r-box">
            <span class="r-con">{{ data.name }}</span>
            <span class="icon-room-mang" @click="goRoomMange(data.id)"></span>
            <span class="icon-edit" @click="editScene(index)"></span>
            <span class="icon-del" @click="delScene(index)"></span>
          </div>
        </div>
      </div>
    </div>


    <mt-popup v-model="popupVisible">
      <div class="smart-modal">
        <h1>{{ uiTitle == 1 ? "添加场景名称" : "修改场景名称" }}</h1>
        <input type="text" name="" id="" v-model="homeName">
        <div class="smart-modal-foot">
          <span @click="hideModal">取消</span>
          <span @click="onSubmit">确定</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import {Popup, Toast} from 'mint-ui';
import HeadNav from '../../headNav/headNav'

export default {
  name: 'add',
  data() {
    return {
      popupVisible: false,
      homeName: null,
      currentIndex: 0,
      sceneId: null,
      list: [],
      disabled: false,
      flag: 1,
      uiTitle: 1
    }
  },
  mounted() {
    this.getEqRoomList();
  },
  components: {
    'HeadNav': HeadNav
  },
  methods: {
    getEqRoomList() {
      let str = '';
      str = str + 'pageNo=1';
      str = str + '&pageSize=100';
      this.Api.useSceneList(str, (msg) => {
        if (msg.code === 200) {
          // localStorage.setItem('isLo',1);
          this.list = msg.data;
        }
      });
    },
    hideModal() {
      this.popupVisible = false;
    },
    showModal() {
      this.popupVisible = true;
      this.flag = 1;
    },
    editScene(index) {
      this.uiTitle = 2;
      let list = this.list;
      this.currentIndex = index;
      this.sceneId = list[index].id;
      this.homeName = list[index].name;
      this.showModal();
    },
    addHome() {
      this.popupVisible = true;
      this.homeName = '';
      this.flag = 2;
      this.uiTitle = 1;
    },
    handleEdit() {
      let params = {};
      params.name = this.homeName;
      params.id = this.sceneId;
      this.Api.editScene(params, (msg) => {
        if (msg.code == 200) {
          Toast('修改成功');
          this.getEqRoomList();
          this.hideModal();
        } else {
          Toast(msg.message);
        }
      })
    },
    handleAdd() {
      if (this.homeName) {
        let params = {};
        params.name = this.homeName;
        if (this.list.length >= 100) {
          this.popupVisible = false;
          Toast('场景最多只能添加100种');
        } else {
          this.Api.useSceneAdd(params, () => {
            this.getEqRoomList();
            this.popupVisible = false;
            this.homeName = null;
          });
        }
        this.popupVisible = false;
        this.homeName = null;
      } else {
        Toast('请填写场景名称')
      }
    },
    onSubmit() {
      let flag = this.flag;
      if (flag == 1) {
        this.handleEdit();
      }

      if (flag == 2) {
        this.handleAdd();
      }
    },
    delScene(index) {
      let data = {
        "id": this.list[index].id
      }
      this.Api.delScene(data, (msg) => {
        if (msg.code === 200) {
          Toast('删除成功');
          this.getEqRoomList();
        } else {
          Toast(msg.message);
        }
      })
    },
    goRoomMange(id) {
      this.$router.push({
        path: this.PATH.getRoomMange() + id
      })
    }
  }
}
</script>

<style scoped>
@import url('../equipment.css');

.list_normal {
  margin-top: 54px;
}

.list_prev .item {
  background-image: none;
}

.list_prev .item:last-child {
  border-bottom: none;
}

/* yh */
.r-box {
  height: 44px;
}

.r-con {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 70%;
}

/*  */
.titles {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>




// WEBPACK FOOTER //
// src/components/equipment/scene/sceneMange.vue